import { RoleService } from '../../../services/role/role.service';


export const useRole = () => {

    const getRoleAutocomplete = () => {
        return new Promise<any>((res, rej) => {
            RoleService.getAutocomplete()
                .then(({ data }) => {
                    // console.log(data)
                    if (data.ok) {
                        res(data);
                    } else {
                        res(undefined)
                    }
                })
                .catch((e) => {
                    console.log(e)
                    rej(e)
                })

        })
    }




    return {
      
        getRoleAutocomplete,
        
        autocomplete: getRoleAutocomplete,
       
    }
}